import { createApp } from '@o-din/app';

import Maintenance from '@o-din-maintenance/src/o-din-maintenance';
import Lk from '@o-din-lk/src/o-din-lk';
import Report from '@o-din-report/src/o-din-report';
import Stock from '@o-din-stock/src/o-din-stock';

createApp('#app', [Maintenance, Lk, Report, Stock]);
